import { useNavigate } from 'react-router'
import { BarChart3 } from 'lucide-react'
import { Badge, Card, Empty, PageHeader, Table, type Column } from '@concours/ui'
import { RANKING_VARIANT, useResultsStages, type ResultsStage } from '../../lib/results'

/** Résultats : étapes en notation ou closes, avec la version courante du classement. */
export function ResultsPage() {
  const navigate = useNavigate()
  const stages = useResultsStages()
  const columns: Column<ResultsStage>[] = [
    {
      key: 'competition',
      header: 'Concours',
      cell: (s) => (
        <span className="stack" style={{ gap: 2 }}>
          <strong>{s.competition.title}</strong>
          <span className="mono muted">{s.competition.reference}</span>
        </span>
      ),
    },
    { key: 'stage', header: 'Étape', cell: (s) => `${s.position}. ${s.label}` },
    {
      key: 'ranking',
      header: 'Classement',
      cell: (s) =>
        s.ranking ? (
          <span className="row" style={{ gap: 'var(--space-2)' }}>
            <span>v{s.ranking.version}</span>
            <Badge variant={RANKING_VARIANT[s.ranking.status]}>{s.ranking.statusLabel}</Badge>
          </span>
        ) : (
          <span className="muted">Non calculé</span>
        ),
    },
    {
      key: 'passed',
      header: 'Admis',
      numeric: true,
      cell: (s) => s.ranking?.summary.counts?.passed ?? '—',
    },
    {
      key: 'pending',
      header: 'À trancher',
      numeric: true,
      cell: (s) =>
        s.ranking?.summary.pending ? (
          <Badge variant="warning">{s.ranking.summary.pending}</Badge>
        ) : (
          '—'
        ),
    },
  ]
  return (
    <>
      <PageHeader
        eyebrow="Sélection"
        title="Résultats et classements"
        description="Calcul des notes d’étape selon la version VALIDÉE des règles de passage, classements versionnés, ex æquo à trancher, comparaison des versions."
      />
      <Card>
        <Table
          columns={columns}
          rows={stages.data ?? []}
          rowKey={(s) => s.id}
          loading={stages.isPending}
          caption="Étapes"
          onRowClick={(s) => navigate(`/resultats/${s.id}`)}
          empty={
            <Empty
              icon={<BarChart3 aria-hidden="true" />}
              title="Aucune étape en notation"
              description="Les étapes apparaissent ici une fois leur notation ouverte."
            />
          }
        />
      </Card>
    </>
  )
}
